export const GET_CASES_REQUEST = "ALL_CASES/GET_CASES_REQUEST";
export const GET_CASES_SUCCESS = "ALL_CASES/GET_CASES_SUCCESS";
export const GET_CASES_FAILURE = "ALL_CASES/GET_CASES_FAILURE";

export const CHANGE_CASE_STATUS_REQUEST = "ALL_CASES/CHANGE_CASE_STATUS_REQUEST";
export const CHANGE_CASE_STATUS_SUCCESS = "ALL_CASES/CHANGE_CASE_STATUS_SUCCESS";
export const CHANGE_CASE_STATUS_FAILURE = "ALL_CASES/CHANGE_CASE_STATUS_FAILURE";

export const GET_CASE_DETAILS_REQUEST = "ALL_CASES/GET_CASE_DETAILS_REQUEST";
export const GET_CASE_DETAILS_SUCCESS = "ALL_CASES/GET_CASE_DETAILS_SUCCESS";
export const GET_CASE_DETAILS_FAILURE = "ALL_CASES/GET_CASE_DETAILS_FAILURE";



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AllCases/constants.js